"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localized_strings_1 = __importDefault(require("localized-strings"));
const locales = new localized_strings_1.default({
    en: {
        bic: '**BIC**: {bic}',
        heading: 'Payment information',
        iban: '**IBAN**: {iban}',
        label: '**Reference**: {publicPaymentId} (to include in the transfer reference for easy payment identification)',
        swiftBic: '**BIC of our partner bank for a SWIFT transfer**: TRWIBEB3',
    },
    fr: {
        bic: '**BIC\xa0**: {bic}',
        heading: 'Informations de paiement',
        iban: '**IBAN\xa0**: {iban}',
        label: "**Libellé\xa0**: {publicPaymentId} (à inclure dans le libellé pour faciliter l'identification de votre paiement)",
        swiftBic: '**BIC banque partenaire pour un virement SWIFT\xa0**: TRWIBEB3',
    },
});
exports.default = locales;
